"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStudyYearDataByDate = exports.getStudyYearData = void 0;
var _dates = require("./dates");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var STUDY_YEAR_DATA = {
  startDay: 1,
  startMonth: 8,
  endDay: 31,
  endMonth: 7,
  semesters: {
    // 2 Semesters Dates
    2: {
      A: {
        startDay: 1,
        startMonth: 8,
        startYearOffset: 0,
        endDay: 31,
        endMonth: 1,
        endYearOffset: 1
      },
      B: {
        startDay: 1,
        startMonth: 2,
        startYearOffset: 1,
        endDay: 31,
        endMonth: 7,
        endYearOffset: 1
      }
    },
    // 3 Semesters Dates
    3: {
      A: {
        startDay: 1,
        startMonth: 8,
        startYearOffset: 0,
        endDay: 21,
        endMonth: 12,
        endYearOffset: 0
      },
      B: {
        startDay: 8,
        startMonth: 1,
        startYearOffset: 1,
        endDay: 1,
        endMonth: 4,
        endYearOffset: 1
      },
      C: {
        startDay: 18,
        startMonth: 4,
        startYearOffset: 1,
        endDay: 31,
        endMonth: 7,
        endYearOffset: 1
      }
    }
  }
};
var getStudyYearData = function getStudyYearData(startYear) {
  var numOfSemesters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var semestersData = STUDY_YEAR_DATA.semesters;
  var semesterData = semestersData[numOfSemesters];
  var studyYearSemesters = {};
  Object.entries(semesterData).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      semesterKey = _ref2[0],
      semester = _ref2[1];
    studyYearSemesters[semesterKey] = _objectSpread(_objectSpread({}, semester), {}, {
      start: new Date(startYear + semester.startYearOffset, semester.startMonth - 1, semester.startDay, 0, 0, 0),
      end: new Date(startYear + semester.endYearOffset, semester.endMonth - 1, semester.endDay, 23, 59, 59)
    });
  });
  return {
    startYear: startYear,
    endYear: startYear + 1,
    title: "".concat(startYear, "/").concat(startYear + 1),
    jewishTitle: (0, _dates.calcJewishYear)(startYear + 1),
    start: new Date(startYear, STUDY_YEAR_DATA.startMonth - 1, STUDY_YEAR_DATA.startDay, 0, 0, 0),
    end: new Date(startYear + 1, STUDY_YEAR_DATA.endMonth - 1, STUDY_YEAR_DATA.endDay, 23, 59, 59),
    semesters: studyYearSemesters
  };
};
exports.getStudyYearData = getStudyYearData;
var getStudyYearDataByDate = function getStudyYearDataByDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var numOfSemesters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var startYear = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var startYearStr = "".concat(STUDY_YEAR_DATA.startMonth.toString().padStart(2, '0'), "/").concat(STUDY_YEAR_DATA.startDay.toString().padStart(2, '0'));
  var theDateStr = "".concat(month.toString().padStart(2, '0'), "/").concat(day.toString().padStart(2, '0'));
  if (startYearStr > theDateStr) {
    startYear--;
  }
  return getStudyYearData(startYear, numOfSemesters);
};
exports.getStudyYearDataByDate = getStudyYearDataByDate;